(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      // Initialize slim banners array and top banner reference
      this.slimBanners = this.slimBanners || [];
      this.topBanner = document.querySelector('.announcement-bar-section--sticky');

      this.setHeaderHeight();
      this.updateSlimBannerPositions(window.scrollY);

      window.matchMedia('(max-width: 990px)').addEventListener('change', () => {
        this.setHeaderHeight();
        this.updateSlimBannerPositions(window.scrollY);
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    updateSlimBannerPositions(scrollTop) {
      if (!this.slimBanners || this.slimBanners.length === 0) return;

      this.slimBanners.forEach((slimBanner, index) => {
        if (scrollTop === 0) {
          // Reset styles
          slimBanner.style.position = '';
          slimBanner.style.top = '';
          slimBanner.style.left = '';
          slimBanner.style.right = '';
          slimBanner.style.width = '';
          slimBanner.style.zIndex = '';
        } else {
          // Calculate baseOffset only when needed
          const topBannerHeight = this.topBanner?.offsetHeight || 0;
          const baseOffset = topBannerHeight + this.header.offsetHeight - 1;

          // Calculate stacked position
          let topPosition = baseOffset;
          for (let i = 0; i < index; i++) {
            if (this.slimBanners[i]) {
              topPosition += this.slimBanners[i].offsetHeight;
            }
          }

          // Apply fixed positioning
          slimBanner.classList.add('slim-banner--fixed-position');
          slimBanner.classList.remove('slim-banner--reset');
          slimBanner.style.position = 'fixed';
          slimBanner.style.top = `${topPosition}px`;
          slimBanner.style.left = '0';
          slimBanner.style.right = '0';
          slimBanner.style.width = '100%';
          slimBanner.style.zIndex = '10';
        }
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const topBannerHeight = this.topBanner ? this.topBanner.offsetHeight : 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Update slim banners position based on scroll
      this.updateSlimBannerPositions(scrollTop);

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
  class StickyCheckout extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.cart_button = document.querySelector('.cart__ctas #checkout');
      this.sticky_checkout = document.querySelector('.cart-sticky-checkout');
      this.createObserver();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        // If element is in the viewport
        if (entries[0].isIntersecting === true) {
          this.hide();
        } else {
          this.reveal();
        }
      });

      observer.observe(this.cart_button);
    }

    hide() {
      this.sticky_checkout.classList.add('cart-sticky-checkout-hidden');
    }

    reveal() {
      this.sticky_checkout.classList.add('animate');
      this.sticky_checkout.classList.remove('cart-sticky-checkout-hidden');
    }
  }

  customElements.define('sticky-checkout', StickyCheckout);

  } catch(e) { console.error(e); }
})();
})();
